module.exports = __webpack_public_path__ + "static/logo_active@2x-8a9e02df64d664f02ffc1ceaaa5ad4fd.png";